import { useWatchfaceStore } from '@/store/use-watchface-store';
import { computed } from 'vue';

export const useIfttt = () => {
  const watchfaceStore = useWatchfaceStore();
  const deviceType = computed(() => watchfaceStore.deviceType);

  const isO61 = deviceType.value === 'O61';
  const isQ63 = deviceType.value === 'Q63';
  const isQ66 = deviceType.value === 'Q66';

  const compareTypeOptions: {
    value: Compare['type'];
    label: string;
    disabled?: boolean;
  }[] = [
    // 和固件 张明育沟通，只支持 '当…时'
    { value: 'when', label: '当…时' }
    // { value: 'click', label: '点击', disabled: isO61 }
    // { value: 'turnBright', label: '亮屏后' },
    // { value: 'turnAOD', label: '息屏后' },
    // { value: 'gravitySensor', label: '重力感应' },
    // { value: 'rotateCrown', label: '旋转表冠' }
  ];

  const animationTypeOptions: {
    label: string;
    value: IAnimation['type'];
    disabled?: boolean;
  }[] = [
    // { label: '位移', value: 'position', disabled: isO61 || isQ63 || isQ66 },
    // { label: '缩放', value: 'scale', disabled: isO61 || isQ63 || isQ66 },
    // { label: '旋转', value: 'rotation', disabled: isO61 || isQ63 || isQ66 },
    // { label: '不透明度', value: 'alpha', disabled: isO61 || isQ63 || isQ66 },
    { label: '显示', value: 'show' }
  ];

  return {
    compareTypeOptions,
    animationTypeOptions
  };
};
